module.exports = __webpack_public_path__ + "img/cara_1kl.3f5f8eb4.jpg";